import { call, put, select, takeEvery } from 'redux-saga/effects';
import { FetchPagedSalesCalls, ISalesCall, salesCallActionCreators, SalesCallActionKeys } from '..';
import { IState } from '../..';
import { IPagedResponse } from '../../apiInterfaces';
import { FilterTypes, getFilteredSalesDistricts, getFilters, ISalesCallFilters } from '../../filters';
import * as api from '../salesCallApi';

function* fetchPagedSalesCallsSaga(action: FetchPagedSalesCalls) {
  yield put(salesCallActionCreators.toggleLoadingPaged());

  if (action.payload.reset) {
    yield put(salesCallActionCreators.resetSalesCallIds());
  }

  const filters: ISalesCallFilters = yield select((state: IState) => getFilters(state, FilterTypes.salesCalls));

  const sds: string[] = yield select((state: IState) => getFilteredSalesDistricts(state, filters));

  try {
    const response: IPagedResponse<ISalesCall> = yield call(
      api.FetchPagedSalesCalls,
      { ...filters, salesDistricts: sds },
      action.payload.skip
    );

    yield put(salesCallActionCreators.processSalesCalls(response.items));
    yield put(salesCallActionCreators.setPaged(response));
  } catch {
    //
  }

  yield put(salesCallActionCreators.toggleLoadingPaged());
}

export function* watchFetchPagedSalesCalls() {
  yield takeEvery(SalesCallActionKeys.FETCH_PAGED_SALES_CALLS, fetchPagedSalesCallsSaga);
}
